import React, { useContext } from "react";

import { LocalizedMessage } from "@I18n/Components/LocalizedMessage/LocalizedMessage";

import { IAnyLocalizedString } from "@types";
import { useIntl } from "react-intl";
import I18nContext from "@I18n/Contexts/I18nContext";

export default () => {
  const i18n = useIntl();
  const { changeLocale } = useContext(I18nContext);

  function localize(LocalizedString: IAnyLocalizedString): JSX.Element;
  function localize(
    LocalizedString: IAnyLocalizedString,
    html?: true
  ): JSX.Element;
  function localize(LocalizedString: IAnyLocalizedString, html?: false): string;
  function localize(localizedString: IAnyLocalizedString, html = true) {
    if (html) return <LocalizedMessage localizedString={localizedString} />;

    return localizedString[i18n.locale] || localizedString.en;
  }

  return {
    ...i18n,
    localize,
    changeLocale,
  };
};
